/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JumboGetoauthverifyGetOAuthVerifyResult
 */
export interface JumboGetoauthverifyGetOAuthVerifyResult {
    /**
     * 
     * @type {string}
     * @memberof JumboGetoauthverifyGetOAuthVerifyResult
     */
    entity_id?: string;
}

/**
 * Check if a given object implements the JumboGetoauthverifyGetOAuthVerifyResult interface.
 */
export function instanceOfJumboGetoauthverifyGetOAuthVerifyResult(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function JumboGetoauthverifyGetOAuthVerifyResultFromJSON(json: any): JumboGetoauthverifyGetOAuthVerifyResult {
    return JumboGetoauthverifyGetOAuthVerifyResultFromJSONTyped(json, false);
}

export function JumboGetoauthverifyGetOAuthVerifyResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): JumboGetoauthverifyGetOAuthVerifyResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'entity_id': !exists(json, 'entity_id') ? undefined : json['entity_id'],
    };
}

export function JumboGetoauthverifyGetOAuthVerifyResultToJSON(value?: JumboGetoauthverifyGetOAuthVerifyResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'entity_id': value.entity_id,
    };
}

